export default "__VITE_ASSET__Bm0L0Blg__"